module.exports = __webpack_public_path__ + "static/img/img5.e2ec1e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/img5.png
// module id = ILdb
// module chunks = 1